export default {
    create: 'Create time trigger',
    list: {
        headers: {
            name: 'Name',
            schedule: 'Schedule',
            workflow: 'Workflow',
            enabled: 'Enabled',
            'next-fire': 'Next fire',
            'last-fire': 'Last fire',
        },
        'schedule-finished': 'Schedule finished',
        'never-fired': 'Never fired',
        'toggle-label': 'Enable {name}',
        empty: {
            title: 'No time triggers found',
            message: 'Create a time trigger to start a workflow on a schedule.',
        },
    },
    actions: {
        title: 'Actions',
        edit: 'Edit',
        delete: 'Delete',
        'delete-confirm': {
            title: 'Delete "{name}"?',
            description: 'The trigger stops firing and this cannot be undone.',
        },
        deleted: 'Time trigger deleted',
    },
    form: {
        'create-title': 'Create time trigger',
        'edit-title': 'Edit time trigger',
        name: 'Name',
        'name-placeholder': 'Trigger name',
        'schedule-type': 'Schedule type',
        cron: 'Cron',
        interval: 'Interval',
        'cron-expression': 'Cron expression',
        'cron-hint': '6 fields: second minute hour day-of-month month day-of-week. The seconds field must be 0.',
        'interval-hint': 'ISO-8601 duration, at least one minute, e.g. PT15M, PT2H, P1D.',
        'utc-hint': 'Schedules run in UTC.',
        'next-runs': 'Next scheduled runs:',
        'target-workflow': 'Target workflow',
        'target-workflow-placeholder': 'Select workflow',
        created: 'Time trigger created',
        updated: 'Time trigger updated',
    },
    errors: {
        name: {
            required: 'Trigger name is required',
        },
        scheduleExpression: {
            required: 'Schedule expression is required',
            invalidCron: 'The cron expression is invalid',
            secondsMustBeZero: 'The seconds field of the cron expression must be 0',
            macroUnsupported: 'Cron macros are not supported',
            invalidInterval: 'The interval is not a valid ISO-8601 duration',
            belowFloor: 'The interval cannot be shorter than one minute',
        },
        targetWorkflowDefinitionId: {
            required: 'Target workflow definition is required',
        },
    },
    interval: {
        every: 'Every {parts}',
        day: '{count} day | {count} days',
        hour: '{count} hour | {count} hours',
        minute: '{count} minute | {count} minutes',
        second: '{count} second | {count} seconds',
    },
}
